<section id="offers" class="educational-offerings-section">
  <div class="section-container">
    <div class="section-header">
      <div class="header-badge">
        <span class="badge-icon">🎁</span>
        <span class="badge-text">Our Offerings</span>
      </div>
      <h2 class="section-title">Comprehensive Educational Services</h2>
      <p class="section-subtitle">
        From primary education to advanced learning, we offer tailored educational experiences for every student
      </p>
    </div>
    <div class="services-grid">
      <div class="service-card premium" *ngFor="let service of educationalServices; let i = index">
        <div class="card-header">
          <div class="service-icon-wrapper">
            <span class="service-icon">{{ service.icon }}</span>
          </div>
          <div class="service-info">
            <h3 class="service-title">{{ service.title }}</h3>
            <p class="service-description">{{ service.description }}</p>
          </div>
        </div>
        <div class="card-content">
          <div class="service-highlights">
            <div class="feature-tag" *ngFor="let feature of service.features">
              <span class="tag-text">{{ feature }}</span>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="service-details">
            <div class="service-badge">
              <span class="badge-text">Available Now</span>
            </div>
          </div>
        </div>
        <div class="card-shine"></div>
      </div>
    </div>
  </div>
</section>